export enum LegalFormalityCreationEnum {
  creationCollectToDo = 'creation_collect_to_do',
  creationCollectAwaitingCustomer = 'creation_collect_awaiting_customer',
  creationCollectToFix = 'creation_collect_to_fix',
  creationCollectToCheck = 'creation_collect_to_check',
  creationDepositAwaitingCustomer = 'creation_deposit_awaiting_customer',
  creationDepositToInvit = 'creation_deposit_to_invit',
  creationDepositNotaryToInform = 'creation_deposit_notary_to_inform',
  creationDepositAwaitingNotary = 'creation_deposit_awaiting_notary',
  creationStatutesToProduce = 'creation_statutes_to_produce',
  creationStatutesToSign = 'creation_statutes_to_sign',
  creationStatutesAwaiting = 'creation_statutes_awaiting',
  creationStatutesToFix = 'creation_statutes_to_fix',
  creationRegistrationAwaitingApproval = 'creation_registration_awaiting_approval',
  creationRegistrationToDo = 'creation_registration_to_do',
  creationRegistrationToSign = 'creation_registration_to_sign',
  creationRegistrationToPay = 'creation_registration_to_pay',
  creationRegistrationAwaitingOrganism = 'creation_registration_awaiting_organism',
  creationRegistrationToRegularize = 'creation_registration_to_regularize',
  creationRegistrationToRedo = 'creation_registration_to_redo',
  creationRegistrationToDoApproval = 'creation_registration_to_do_approval',
  creationCapitalReleaseRibToRequest = 'creation_capital_release_rib_to_request',
  creationCapitalReleaseAwaitingCustomerRib = 'creation_capital_release_awaiting_customer_rib',
  creationCapitalReleaseAwaitingTiimeRib = 'creation_capital_release_awaiting_tiime_rib',
  creationCapitalReleaseNotaryToInform = 'creation_capital_release_notary_to_inform',
  creationCapitalReleaseAwaitingNotary = 'creation_capital_release_awaiting_notary',
  creationCompleted = 'creation_completed',
  creationAnomaly = 'creation_anomaly'
}
